import React from "react";
import { RequestResponses } from "../state/request-interfaces";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

function RequestResponsesList({ requestResponses }: { requestResponses: RequestResponses[] }) {
    const { t } = useTranslation();

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {requestResponses.map((response, index) => (
                <div key={index}>
                    <p style={{ marginBottom: "0px" }}>
                        {response.status === "Approved" ? t("Approved") : t("Declined")} {t("by")}: {response.fullName}
                    </p>
                    {response.comment && (
                        <p style={{ marginBottom: "0px" }}>
                            <span>{t("Comment")}:</span> {response.comment}
                        </p>
                    )}
                    {response.date && (
                        <p style={{ marginBottom: "0px" }}>
                            <span>{t("Date")}:</span>{" "}
                            {new Date(response.date).toLocaleDateString("en-GB")}
                        </p>
                    )}
                </div>
            ))}
        </div>
    );
};

interface Props {
    requestResponses: RequestResponses[];
    value: string;
}

function CellWithResponsesList({ requestResponses, value }: Props) {

    if (!requestResponses || requestResponses.length === 0) {
        return <p style={{ marginBottom: "0px" }}>{value.toString()}</p>;
    }

    return (
        <Tooltip title={<RequestResponsesList requestResponses={requestResponses} />} placement="left" arrow>
            <p style={{ marginBottom: "0px" }}>{value.toString()}</p>
        </Tooltip>
    );
};

export default CellWithResponsesList;